'use strict';

module.exports = {
    'en-us': {
        prev: 'Previous',
        next: 'Next',
        goTo: 'Go to',
        page: 'Page',
        go: 'Go',
        pageSize: 'Items per page:'
    },
    'zh-cn': {
        prev: '上一页',
        next: '下一页',
        goTo: '到第',
        page: '页',
        go: '确定',
        pageSize: '每页显示：'
    },
    'zh-tw': {
        prev: '上一頁',
        next: '下一頁',
        goTo: '到第',
        page: '頁',
        go: '確定',
        pageSize: '每頁顯示：'
    }
};